import { __makeTemplateObject } from "tslib";
/* stylelint-disable no-descending-specificity */

import styled from 'styled-components';
import LabelBase from './Label';
import LockSmallFilledBase from '../Icons/Lock/LockSmallFilled';
import Typography from '../Typography';
export var HEIGHT = 56;
export var HEIGHT_COMPACT = 48;
export var HEIGHT_SMALL = 40;
export var Root = styled.div.withConfig({
  displayName: "ui-kit-Root",
  componentId: "ui-kit-1emg0z2"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  position: relative;\n  font-family: ", ";\n\n  &.fullWidth {\n    width: 100%;\n  }\n  &.alignRight {\n    text-align: right;\n  }\n"], ["\n  display: inline-block;\n  position: relative;\n  font-family: ", ";\n\n  &.fullWidth {\n    width: 100%;\n  }\n  &.alignRight {\n    text-align: right;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.fontFamily;
});
export var InputRoot = styled.div.withConfig({
  displayName: "ui-kit-InputRoot",
  componentId: "ui-kit-6hw09f"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  cursor: text;\n  caret-color:  ", ";\n  border-color: transparent;\n  background-color: transparent;\n\n  ", ".primary && {\n    border-radius: 8px;\n    background-color: ", ";\n  }\n\n  ", ".primary &:hover {\n    background-color: ", ";\n  }\n\n  ", ".primary.hasFocus && {\n    background-color: ", ";\n    border-color: ", ";\n    box-shadow: 0px 0px 0px 3px ", ";\n  }\n\n  ", ".primary.error && {\n    background-color: ", ";\n  }\n\n  ", ".primary.error.hasFocus && {\n    background-color: ", ";\n    border-color: ", ";\n    box-shadow: 0px 0px 0px 3px ", ";\n  }\n\n  ", ".primary.disabled && {\n    background-color: ", ";\n  }\n\n  ", ".outline && {\n    border-radius: 8px;\n    border-color: ", ";\n  }\n\n  ", ".outline &:hover {\n    border-color: ", ";\n  }\n\n  ", ".outline.hasFocus && {\n    background-color: ", ";\n    border-color: ", ";\n    box-shadow: 0px 0px 0px 3px ", ";\n  }\n\n  ", ".outline.error && {\n    border-color: ", ";\n  }\n\n  ", ".outline.error.hasFocus && {\n    background-color: ", ";\n    border-color: ", ";\n    box-shadow: 0px 0px 0px 3px ", ";\n  }\n\n  ", ".outline.disabled && {\n    border-color: ", ";\n  }\n"], ["\n  position: relative;\n  display: flex;\n  align-items: center;\n  cursor: text;\n  caret-color:  ", ";\n  border-color: transparent;\n  background-color: transparent;\n\n  "
/* sc-sel */
, ".primary && {\n    border-radius: 8px;\n    background-color: ", ";\n  }\n\n  "
/* sc-sel */
, ".primary &:hover {\n    background-color: ", ";\n  }\n\n  "
/* sc-sel */
, ".primary.hasFocus && {\n    background-color: ", ";\n    border-color: ", ";\n    box-shadow: 0px 0px 0px 3px ", ";\n  }\n\n  "
/* sc-sel */
, ".primary.error && {\n    background-color: ", ";\n  }\n\n  "
/* sc-sel */
, ".primary.error.hasFocus && {\n    background-color: ", ";\n    border-color: ", ";\n    box-shadow: 0px 0px 0px 3px ", ";\n  }\n\n  "
/* sc-sel */
, ".primary.disabled && {\n    background-color: ", ";\n  }\n\n  "
/* sc-sel */
, ".outline && {\n    border-radius: 8px;\n    border-color: ", ";\n  }\n\n  "
/* sc-sel */
, ".outline &:hover {\n    border-color: ", ";\n  }\n\n  "
/* sc-sel */
, ".outline.hasFocus && {\n    background-color: ", ";\n    border-color: ", ";\n    box-shadow: 0px 0px 0px 3px ", ";\n  }\n\n  "
/* sc-sel */
, ".outline.error && {\n    border-color: ", ";\n  }\n\n  "
/* sc-sel */
, ".outline.error.hasFocus && {\n    background-color: ", ";\n    border-color: ", ";\n    box-shadow: 0px 0px 0px 3px ", ";\n  }\n\n  "
/* sc-sel */
, ".outline.disabled && {\n    border-color: ", ";\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.palette.label.accent;
},
/* sc-sel */
Root, function (_a) {
  var theme = _a.theme;
  return theme.palette.fill.secondary.overlay16;
},
/* sc-sel */
Root, function (_a) {
  var theme = _a.theme;
  return theme.palette.fill.secondary.overlay24;
},
/* sc-sel */
Root, function (_a) {
  var theme = _a.theme;
  return theme.palette.background.neutral.primaryTransparent;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.fill.primary.mid;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.fill.primary.overlay24;
},
/* sc-sel */
Root, function (_a) {
  var theme = _a.theme;
  return theme.palette.fill.negative.overlay16;
},
/* sc-sel */
Root, function (_a) {
  var theme = _a.theme;
  return theme.palette.background.neutral.primaryTransparent;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.fill.negative.mid;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.fill.negative.overlay24;
},
/* sc-sel */
Root, function (_a) {
  var theme = _a.theme;
  return theme.palette.fill.secondary.overlay8;
},
/* sc-sel */
Root, function (_a) {
  var theme = _a.theme;
  return theme.palette.fill.secondary.low;
},
/* sc-sel */
Root, function (_a) {
  var theme = _a.theme;
  return theme.palette.fill.secondary.mid;
},
/* sc-sel */
Root, function (_a) {
  var theme = _a.theme;
  return theme.palette.background.neutral.primaryTransparent;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.fill.primary.mid;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.fill.primary.overlay24;
},
/* sc-sel */
Root, function (_a) {
  var theme = _a.theme;
  return theme.palette.fill.negative.mid;
},
/* sc-sel */
Root, function (_a) {
  var theme = _a.theme;
  return theme.palette.background.neutral.primaryTransparent;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.fill.negative.mid;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.fill.negative.overlay24;
},
/* sc-sel */
Root, function (_a) {
  var theme = _a.theme;
  return theme.palette.fill.secondary.muted;
});
export var Border = styled.div.withConfig({
  displayName: "ui-kit-Border",
  componentId: "ui-kit-xi6f85"
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  pointer-events: none;\n  border-radius: inherit;\n  border: 1px solid transparent;\n  background-color: transparent;\n  border-color: inherit;\n"], ["\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  pointer-events: none;\n  border-radius: inherit;\n  border: 1px solid transparent;\n  background-color: transparent;\n  border-color: inherit;\n"])));
export var InputContainer = styled.div.withConfig({
  displayName: "ui-kit-InputContainer",
  componentId: "ui-kit-1civq1e"
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  flex: auto;\n  min-width: 0;\n  position: relative;\n  display: inline-block;\n"], ["\n  flex: auto;\n  min-width: 0;\n  position: relative;\n  display: inline-block;\n"])));
export var Adornment = styled.div.withConfig({
  displayName: "ui-kit-Adornment",
  componentId: "ui-kit-1hdexln"
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n\n  ", ".textarea & {\n    align-self: flex-start;\n    margin-top: 6px;\n  }\n\n  & > * + * {\n    margin-left: 8px;\n  }\n\n  & > *:not(.ui-input__lock):not(.ui-number-field__steps):not(.ui-input__secondary-label):last-child {\n    margin-right: 12px;\n  }\n\n  & > .ui-input__secondary-label:last-child {\n    margin-right: 16px;\n  }\n"], ["\n  display: inline-flex;\n  align-items: center;\n\n  "
/* sc-sel */
, ".textarea & {\n    align-self: flex-start;\n    margin-top: 6px;\n  }\n\n  & > * + * {\n    margin-left: 8px;\n  }\n\n  & > *:not(.ui-input__lock):not(.ui-number-field__steps):not(.ui-input__secondary-label):last-child {\n    margin-right: 12px;\n  }\n\n  & > .ui-input__secondary-label:last-child {\n    margin-right: 16px;\n  }\n"])),
/* sc-sel */
Root);
export var SecondaryLabel = styled(Typography).withConfig({
  displayName: "ui-kit-SecondaryLabel",
  componentId: "ui-kit-xk05h9"
})(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  padding: 8px 0 8px 4px;\n"], ["\n  padding: 8px 0 8px 4px;\n"])));
export var InputElement = styled.input.withConfig({
  displayName: "ui-kit-InputElement",
  componentId: "ui-kit-1quf49p"
})(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  box-sizing: border-box;\n  width: 100%;\n  height: ", "px;\n  padding: 16px 12px 16px 16px;\n  /* body 16/regular */\n  font-family: inherit;\n  color: ", ";\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: -0.008em;\n  background: transparent;\n  outline: none;\n  border: none;\n\n  &::placeholder {\n    color: ", ";\n  }\n\n  /* \u0423\u0431\u0438\u0440\u0430\u0435\u0442 default input margin \u0438\u0437 safari */\n  margin: 0;\n\n  /* \u0423\u0431\u0438\u0440\u0430\u0435\u0442 \u0441\u0438\u043D\u044E\u044E \u0437\u0430\u043B\u0438\u0432\u043A\u0443 \u043F\u0440\u0438 \u0430\u0432\u0442\u043E\u043A\u043E\u043C\u043F\u043B\u0438\u0442\u0435 */\n  &:-webkit-autofill,\n  &:-webkit-autofill:hover,\n  &:-webkit-autofill:focus,\n  &:-webkit-autofill:active {\n    &:first-line {\n      font-family: ", ";\n      font-size: 16px;\n      line-height: 24px;\n      letter-spacing: -0.008em;\n\n      ", ":not(.regular) & {\n        font-size: 14px;\n        line-height: 20px;\n        letter-spacing: -0.004em;\n      }\n    }\n\n    -webkit-text-fill-color: ", ";\n\n    /* Hack from http://stackoverflow.com/a/29350537 */\n    transition: background-color 999999s ease-in-out 0s;\n  }\n\n  /* \u0423\u0431\u0438\u0440\u0430\u0435\u0442 \u0434\u0435\u0444\u043E\u043B\u0442\u043D\u044B\u0439 \u043F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0430\u0442\u0435\u043B\u044C \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F \u043F\u0430\u0440\u043E\u043B\u044F \u0432 Edge */\n  &::-ms-reveal {\n    display: none;\n  }\n\n  ", ".alignRight & {\n    text-align: right;\n  }\n\n  ", ".compact &, ", ".small & {\n    /* body 14/regular */\n    font-size: 14px;\n    line-height: 20px;\n    letter-spacing: -0.004em;\n  }\n\n  ", ".compact & {\n    height: ", "px;\n    padding-top: 14px;\n    padding-bottom: 14px;\n  }\n\n  ", ".small & {\n    height: ", "px;\n    padding-top: 10px;\n    padding-bottom: 10px;\n  }\n\n  ", ".withLabel & {\n    padding-top: 24px;\n    padding-bottom: 8px;\n  }\n\n  ", ".compact.withLabel & {\n    padding-top: 22px;\n    padding-bottom: 6px;\n  }\n\n  ", ".disabled && {\n    color: ", ";\n    -webkit-text-fill-color: currentcolor;\n  }\n"], ["\n  box-sizing: border-box;\n  width: 100%;\n  height: ", "px;\n  padding: 16px 12px 16px 16px;\n  /* body 16/regular */\n  font-family: inherit;\n  color: ", ";\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: -0.008em;\n  background: transparent;\n  outline: none;\n  border: none;\n\n  &::placeholder {\n    color: ", ";\n  }\n\n  /* \u0423\u0431\u0438\u0440\u0430\u0435\u0442 default input margin \u0438\u0437 safari */\n  margin: 0;\n\n  /* \u0423\u0431\u0438\u0440\u0430\u0435\u0442 \u0441\u0438\u043D\u044E\u044E \u0437\u0430\u043B\u0438\u0432\u043A\u0443 \u043F\u0440\u0438 \u0430\u0432\u0442\u043E\u043A\u043E\u043C\u043F\u043B\u0438\u0442\u0435 */\n  &:-webkit-autofill,\n  &:-webkit-autofill:hover,\n  &:-webkit-autofill:focus,\n  &:-webkit-autofill:active {\n    &:first-line {\n      font-family: ", ";\n      font-size: 16px;\n      line-height: 24px;\n      letter-spacing: -0.008em;\n\n      "
/* sc-sel */
, ":not(.regular) & {\n        font-size: 14px;\n        line-height: 20px;\n        letter-spacing: -0.004em;\n      }\n    }\n\n    -webkit-text-fill-color: ", ";\n\n    /* Hack from http://stackoverflow.com/a/29350537 */\n    transition: background-color 999999s ease-in-out 0s;\n  }\n\n  /* \u0423\u0431\u0438\u0440\u0430\u0435\u0442 \u0434\u0435\u0444\u043E\u043B\u0442\u043D\u044B\u0439 \u043F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0430\u0442\u0435\u043B\u044C \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F \u043F\u0430\u0440\u043E\u043B\u044F \u0432 Edge */\n  &::-ms-reveal {\n    display: none;\n  }\n\n  "
/* sc-sel */
, ".alignRight & {\n    text-align: right;\n  }\n\n  "
/* sc-sel */
, ".compact &, "
/* sc-sel */
, ".small & {\n    /* body 14/regular */\n    font-size: 14px;\n    line-height: 20px;\n    letter-spacing: -0.004em;\n  }\n\n  "
/* sc-sel */
, ".compact & {\n    height: ", "px;\n    padding-top: 14px;\n    padding-bottom: 14px;\n  }\n\n  "
/* sc-sel */
, ".small & {\n    height: ", "px;\n    padding-top: 10px;\n    padding-bottom: 10px;\n  }\n\n  "
/* sc-sel */
, ".withLabel & {\n    padding-top: 24px;\n    padding-bottom: 8px;\n  }\n\n  "
/* sc-sel */
, ".compact.withLabel & {\n    padding-top: 22px;\n    padding-bottom: 6px;\n  }\n\n  "
/* sc-sel */
, ".disabled && {\n    color: ", ";\n    -webkit-text-fill-color: currentcolor;\n  }\n"])), HEIGHT, function (_a) {
  var theme = _a.theme;
  return theme.palette.label.primary;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.label.placeholder;
}, function (_a) {
  var theme = _a.theme;
  return theme.fontFamily;
},
/* sc-sel */
Root, function (_a) {
  var theme = _a.theme;
  return theme.palette.label.primary;
},
/* sc-sel */
Root,
/* sc-sel */
Root,
/* sc-sel */
Root,
/* sc-sel */
Root, HEIGHT_COMPACT,
/* sc-sel */
Root, HEIGHT_SMALL,
/* sc-sel */
Root,
/* sc-sel */
Root,
/* sc-sel */
Root, function (_a) {
  var theme = _a.theme;
  return theme.palette.label.inactive;
});
export var Highlight = styled.span.withConfig({
  displayName: "ui-kit-Highlight",
  componentId: "ui-kit-zwvry8"
})(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  position: absolute;\n  box-sizing: content-box;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  /* 28px - \u043F\u0430\u0434\u0434\u0438\u043D\u0433\u0438 \u0443 input */\n  max-width: calc(100% - 28px);\n  font-size: 16px;\n  line-height: 24px;\n  font-family: inherit;\n  color: transparent;\n  letter-spacing: -0.008em;\n  background-color: ", ";\n  padding: 2px 4px;\n  border-radius: 4px;\n  pointer-events: none;\n\n  &.compact, &.small {\n    font-size: 14px;\n    line-height: 20px;\n    letter-spacing: -0.004em;\n  }\n\n  &.withLabel {\n    margin-top: 8px;\n  }\n"], ["\n  position: absolute;\n  box-sizing: content-box;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  /* 28px - \u043F\u0430\u0434\u0434\u0438\u043D\u0433\u0438 \u0443 input */\n  max-width: calc(100% - 28px);\n  font-size: 16px;\n  line-height: 24px;\n  font-family: inherit;\n  color: transparent;\n  letter-spacing: -0.008em;\n  background-color: ", ";\n  padding: 2px 4px;\n  border-radius: 4px;\n  pointer-events: none;\n\n  &.compact, &.small {\n    font-size: 14px;\n    line-height: 20px;\n    letter-spacing: -0.004em;\n  }\n\n  &.withLabel {\n    margin-top: 8px;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.palette.fill.primary.overlay16;
});
export var Label = styled(LabelBase).withConfig({
  displayName: "ui-kit-Label",
  componentId: "ui-kit-1er2m7a"
})(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  ", ":-webkit-autofill + & {\n    width: calc((100% - 28px) / 0.75);\n    transform: scale(0.75) translateY(5px);\n  }\n"], ["\n  "
/* sc-sel */
, ":-webkit-autofill + & {\n    width: calc((100% - 28px) / 0.75);\n    transform: scale(0.75) translateY(5px);\n  }\n"])),
/* sc-sel */
InputElement);
export var Icon = styled.div.withConfig({
  displayName: "ui-kit-Icon",
  componentId: "ui-kit-7jijk2"
})(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  display: inline-flex;\n\n  & > svg {\n    color: ", ";\n  }\n\n  ", ".disabled & > svg {\n    color: ", ";\n  }\n"], ["\n  display: inline-flex;\n\n  & > svg {\n    color: ", ";\n  }\n\n  "
/* sc-sel */
, ".disabled & > svg {\n    color: ", ";\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.palette.label.secondary;
},
/* sc-sel */
Root, function (_a) {
  var theme = _a.theme;
  return theme.palette.label.inactive;
});
export var LockSmallFilled = styled(LockSmallFilledBase).withConfig({
  displayName: "ui-kit-LockSmallFilled",
  componentId: "ui-kit-1mpxqfm"
})(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  margin-right: 8px;\n  color: ", ";\n"], ["\n  margin-right: 8px;\n  color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.palette.label.placeholder;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;